// Clipboard write with an honest result — callers must only toast success
// when this resolves true.
//
// The execCommand fallback stages its textarea inside `container`. Pass the
// dialog's own content element when copying from inside a modal: MUI's focus
// trap (enforceFocus, on by default) synchronously reclaims focus from any
// element outside the dialog, which deactivates the textarea's selection
// before execCommand("copy") runs — the classic copy-inside-modal pitfall.
export async function copyTextToClipboard(
  text: string,
  container: HTMLElement = document.body,
): Promise<boolean> {
  try {
    await navigator.clipboard.writeText(text);
    return true;
  } catch {
    const textarea = document.createElement("textarea");
    textarea.value = text;
    textarea.style.position = "fixed";
    textarea.style.opacity = "0";
    container.appendChild(textarea);
    textarea.select();
    let copied = false;
    try {
      copied = document.execCommand("copy");
    } catch {
      copied = false;
    }
    container.removeChild(textarea);
    return copied;
  }
}
